import { createRouter, createWebHistory } from "vue-router"
import { useAuthStore } from "@/stores/auth"

import Account from "@/pages/account/Account.vue"
import Auth from "@/pages/Auth.vue"
import Campaigns from "@/pages/campaigns/Campaigns.vue"
import Campaign from "@/pages/campaigns/Campaign.vue"
import CampaignPreviews from "@/pages/campaigns/CampaignPreviews.vue"
import Dashboard from "@/pages/dashboard/Dashboard.vue"
import Finance from "@/pages/finance/Finance.vue"
import ForgotPassword from "@/pages/auth/ForgotPassword.vue"
import Login from "@/pages/auth/Login.vue"
import Impersonate from "@/pages/auth/Impersonate.vue"
import NotFound from "@/pages/NotFound.vue"
import Postbacks from "@/pages/postbacks/Postbacks.vue"
import References from "@/pages/auth/References.vue"
import Register from "@/pages/auth/Register.vue"
import RegisterComplete from "@/pages/auth/RegisterComplete.vue"
import ResetPassword from "@/pages/auth/ResetPassword.vue"
import Reports from "@/pages/reports/Reports.vue"


import SubAffiliates from "@/pages/subAffiliates/SubAffiliates.vue"
import Terms from "@/pages/account/Terms.vue"
import VerifiedEmail from "@/pages/auth/VerifiedEmail.vue"

const routes = [
  { name: "Home", path: "/", component: Login, meta: { layout: "login" } },
  {
    name: "Login",
    path: "/login",
    component: Login,
    meta: { layout: "login" },
  },
  {
    name: "Impersonate",
    path: "/impersonate/:id",
    component: Impersonate,
    props: true,
    meta: { layout: "login" },
  },
  {
    name: "Register",
    path: "/register",
    component: Register,
    meta: { layout: "login" },
  },
  {
    name: "RegisterComplete",
    path: "/register-completed",
    component: RegisterComplete,
    meta: { layout: "login" },
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    meta: { layout: "login" },
  },
  {
    name: "ResetPassword",
    path: "/reset-password/:token",
    component: ResetPassword,
    props: true,
    meta: { layout: "login" },
  },
  {
    name: "References",
    path: "/references/:token",
    component: References,
    props: true,
    meta: { layout: "login" },
  },
  {
    name: "VerifiedEmail",
    path: "/verified-email/:token",
    component: VerifiedEmail,
    props: true,
    meta: { layout: "login" },
  },
  {
    name: "Auth",
    path: "/auth/:token",
    component: Auth,
    props: true,
    meta: { layout: "login" },
  },
  {
    path: "/publisher/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      layout: "default", // Layout with navigation
    },
  },
  {
    path: "/publisher/campaigns",
    name: "Campaigns",
    component: Campaigns,
    meta: {
      requiresAuth: false,
      layout: "default",
    },
  },
  {
    path: "/campaigns/preview/:token",
    name: "Campaign Previews",
    component: CampaignPreviews,
    props: true,
    meta: {
      requiresAuth: false,
      layout: "default",
    },
  },
  {
    path: "/publisher/campaign/:id",
    name: "Campaign",
    component: Campaign,
    props: true,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/reports",
    name: "Reports",
    component: Reports,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/postbacks",
    name: "Postbacks",
    component: Postbacks,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/account",
    name: "Account",
    component: Account,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/finance",
    name: "Finance",
    component: Finance,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/sub-affiliates",
    name: "SubAffiliates",
    component: SubAffiliates,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/publisher/account/terms",
    name: "Terms",
    component: Terms,
    meta: {
      requiresAuth: true,
      layout: "default",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      layout: "login",
    },
  },
]

export function getRouter() {
  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, _from, savedPosition) {
      // Return saved position for browser back/forward
      if (savedPosition) {
        return savedPosition
      }
      // Scroll to hash if present
      if (to.hash) {
        return { el: to.hash }
      }
      // Otherwise scroll to top
      return { top: 0 }
    },
  })

  router.beforeEach((to, _from) => {
    const authStore = useAuthStore()

    if (to.name == "Home" && authStore.isAuthenticated) {
      return {
        name: "Dashboard",
      }
    }

    if (to.name == "Login") {
      authStore.removeAuth()
    }

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
      if (import.meta.env.VITE_YTZ_LOGIN) {
        window.location.href = import.meta.env.VITE_YTZ_LOGIN
      }
      return {
        name: "Login",
      }
    }
  })

  // Also scroll the main content container after navigation
  router.afterEach(() => {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      const scrollContainer = document.getElementById('content-scroll')
      if (scrollContainer) {
        scrollContainer.scrollTop = 0
      }
    }, 0)
  })

  return router
}
